// extracted by mini-css-extract-plugin
module.exports = {"alertBanner":"PaymentMethodsOrderContainer_alertBanner__t5oAq","loyaltyTitle":"PaymentMethodsOrderContainer_loyaltyTitle__cj_Sj"};